import { createRouter, Navigate } from '@tanstack/react-router';
import { queryClient } from '@/lib/query-client';
import { routeTree } from '@/routeTree.gen';
import { ErrorFallback } from '@/shared/error-fallback';

export const router = createRouter({
  routeTree,
  context: { query: queryClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultNotFoundComponent: () => <Navigate to="/" replace />,
  defaultErrorComponent: ErrorFallback,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
